import React from 'react';

export default function EmailCallbackPage() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: '24px' }}>
      <h1>Hello World</h1>
      <p>Email OAuth callback shell (Phase 1C).</p>
    </main>
  );
}
